"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EconomyCard = exports.EconomyCardDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var card_1 = require("../elements/card");
var content_1 = require("../elements/content");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_icons_1 = require("../../hooks/use-icons");
var icon_label_1 = require("../elements/icon-label");
var entity_image_1 = require("./entity-image");
var entity_count_label_1 = require("./entity-count-label");
var entity_cell_header_1 = require("./entity-cell-header");
var entity_list_1 = require("./entity-list");
var MAP_PARAMS = 'format=png&maptype=roadmap&style=element:geometry%7Ccolor:0xf5f5f5&style=element:labels.icon%7Cvisibility:off&style=element:labels.text.fill%7Ccolor:0x616161&style=element:labels.text.stroke%7Ccolor:0xf5f5f5&style=feature:administrative.land_parcel%7Celement:labels.text.fill%7Ccolor:0xbdbdbd&style=feature:poi%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:poi%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:poi.park%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:poi.park%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:road%7Celement:geometry%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:geometry.fill%7Ccolor:0xd7d7d7&style=feature:road.arterial%7Celement:labels.text.fill%7Ccolor:0x757575&style=feature:road.highway%7Celement:geometry%7Ccolor:0xdadada&style=feature:road.highway%7Celement:labels.text.fill%7Ccolor:0x616161&style=feature:road.local%7Celement:geometry.fill%7Ccolor:0x929292&style=feature:road.local%7Celement:labels.text.fill%7Ccolor:0x9e9e9e&style=feature:transit.line%7Celement:geometry%7Ccolor:0xe5e5e5&style=feature:transit.station%7Celement:geometry%7Ccolor:0xeeeeee&style=feature:water%7Celement:geometry%7Ccolor:0xc9c9c9&style=feature:water%7Celement:labels.text.fill%7Ccolor:0x9e9e9e';
exports.EconomyCardDefaultProps = {};
// -------- Styles -------->
var CardStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ContentStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "], ["\n    flex-grow: 1;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), theme_1.theme.H_DOT_BG())
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n\n    &:hover {\n      color: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n\n    &:hover {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.FONT_SIZE(21), theme_1.theme.COLOR('dark'), theme_1.theme.UNIT(2), theme_1.theme.COLOR('link-hover'))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(2))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var IconLabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), LabelStyles)
});
var GlobalRegionsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    margin: ", " 0 0;\n    padding-top: ", ";\n    color: ", ";\n  "], ["\n    ", ";\n    margin: ", " 0 0;\n    padding-top: ", ";\n    color: ", ";\n  "])), theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2, 2), theme_1.theme.COLOR('dark'))
});
// -------- Components -------->
var My = {
  Card: (0, styled_components_1.default)(card_1.Card)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  Image: (0, styled_components_1.default)(entity_image_1.EntityImage)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Content: (0, styled_components_1.default)(content_1.Content)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Header: (0, styled_components_1.default)(entity_cell_header_1.EntityCellHeader)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Title: styled_components_1.default.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  CountLabel: (0, styled_components_1.default)(entity_count_label_1.EntityFieldCountLabel)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  IconLabel: (0, styled_components_1.default)(icon_label_1.IconLabel)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), IconLabelStyles),
  GlobalRegions: (0, styled_components_1.default)(entity_list_1.EntityList)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), GlobalRegionsStyles)
};
var EconomyCard = function (props) {
  var className = props.className,
    entity = props.entity,
    hspace = props.hspace;
  var width = 400;
  var height = 225;
  var zoom = 11;
  var center = entity.name;
  var Icons = (0, use_icons_1.useIcons)();
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  var image = {
    id: "image-map-".concat(center),
    url: "https://maps.googleapis.com/maps/api/staticmap?key=".concat(process.env.GOOGLE_SEARCH_API_KEY, "&scale=2&center=").concat(center, "&zoom=").concat(zoom, "&size=").concat(width, "x").concat(height, "&").concat(MAP_PARAMS),
    width: width,
    height: height,
    type: 'image/png'
  };
  var feedEntries = entity.feedEntries,
    locations = entity.locations,
    _a = entity.globalRegions,
    globalRegions = _a === void 0 ? [] : _a,
    impactStories = entity.impactStories,
    people = entity.people,
    organisations = entity.organisations,
    description = entity.description;
  var hasGlobalRegions = !!globalRegions.length;
  return React.createElement(My.Card, __assign({}, props, {
    hspace: hspace,
    space: 4,
    titleMargin: "none",
    to: definition.to(entity.slug),
    className: className,
    image: React.createElement(My.Image, {
      defaultImage: image,
      entity: entity
    })
  }), React.createElement(My.Header, {
    entity: entity
  }), React.createElement(My.Title, null, entity.name), entity.population && React.createElement(My.IconLabel, {
    icon: React.createElement(Icons.PeopleCircle, null)
  }, "Population: ", new Intl.NumberFormat().format(entity.population)), React.createElement(My.CountLabel, {
    entityTypeName: "Location",
    value: locations
  }), React.createElement(My.CountLabel, {
    entityTypeName: "FeedEntry",
    value: feedEntries
  }), React.createElement(My.CountLabel, {
    entityTypeName: "Person",
    value: people
  }), React.createElement(My.CountLabel, {
    entityTypeName: "Organisation",
    value: organisations
  }), React.createElement(My.CountLabel, {
    entityTypeName: "ImpactStory",
    value: impactStories
  }), hasGlobalRegions && React.createElement(My.GlobalRegions, {
    variant: 'card',
    items: globalRegions
  }), description && description.plain && React.createElement(My.Content, {
    tiny: true,
    html: description.plain
  }));
};
exports.EconomyCard = EconomyCard;
exports.EconomyCard.defaultProps = exports.EconomyCardDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;